import { FontIconName } from "client/Components";
import {
	AlertManager,
	useAlerts,
	useIsMounted
} from "client/Hooks";
import { useCallback, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	KnowledgeItemStatisticsModel,
	registerFollowComments,
	unregisterFollowComments
} from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";

export function useFollowAction(
	knowledgeItemId: number,
	isFollowing: boolean,
	onStatisticsChanged: (statistics: KnowledgeItemStatisticsModel) => void
): [
	icon: FontIconName,
	key: LocalizationKey,
	clickHandler: () => void
] {
	const alertManager: AlertManager = useAlerts();
	const isMounted: () => boolean = useIsMounted();

	const clickHandler = useCallback(
		async (): Promise<void> => {
			try {
				const statistics: KnowledgeItemStatisticsModel = isFollowing
					? await unregisterFollowComments(knowledgeItemId)
					: await registerFollowComments(knowledgeItemId);

				if (!isMounted()) {
					return;
				}

				onStatisticsChanged(statistics);
			} catch (e) {
				console.error(e);
				alertManager.showError(localize("_GeneralErrorMessage"));
			}
		},
		[
			alertManager,
			knowledgeItemId,
			isFollowing,
			isMounted,
			onStatisticsChanged
		]
	);

	const { icon, key } = useMemo(
		(): { icon: FontIconName; key: LocalizationKey; } => {
			return isFollowing
				? { icon: "check", key: "_Following" }
				: { icon: "plus", key: "_Follow" };
		},
		[isFollowing]
	);

	return [
		icon,
		key,
		clickHandler
	];
}